import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShellComponent } from './core/layout/shell/shell.component';
import { PromotionPageComponent } from './views/promotion/promotion-page.component';
import { LOCKED_ROUTE_SEGMENTS } from './core/layout/side-nav/side-nav.config';
import { CONNECTOR_ROUTES } from '@core/models/routes';
import { onboardingCompletedGuard } from './core/guards/onboarding-completed.guard';

const routes: Routes = [
    {
        path: '',
        component: ShellComponent,
        children: [
            { path: '', redirectTo: 'onboarding', pathMatch: 'full' },
            {
                path: 'onboarding',
                loadChildren: () => import('./views/onboarding/onboarding.module').then(m => m.OnboardingModule),
            },
            {
                path: 'ai-agents',
                loadChildren: () => import('./views/ai-agents/ai-agents.module').then(m => m.AiAgentsModule),
                canActivate: [onboardingCompletedGuard],
            },
            ...LOCKED_ROUTE_SEGMENTS.map(segment => ({
                path: segment,
                component: PromotionPageComponent,
            })),
            ...Object.values(CONNECTOR_ROUTES).map(segment => ({
                path: segment,
                component: PromotionPageComponent,
            })),
        ],
    },
    { path: '**', redirectTo: '/' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
